export { SEOPageFeature } from './lib/seo-page'
export { storyblokLinkToPath } from './lib/data/seo-page-data'
export type { SEOPageStoryContent } from './lib/types/seo-page'

export { getStaticPropsGenerator } from './lib/get-static-props'
export { getStaticPathsGenerator } from './lib/get-static-paths'
export type { GetStaticPropsGeneratorArgs } from './lib/get-static-props'
